import React, { useEffect, useState } from "react";

import { EditableDetectorFields } from "pages/detectorDetail/DetectorDetail";
import { DEFAULT_CONFIDENCE_THRESHOLD, Detector } from "types/detectors";

export enum DetectorTabs {
  Escalation = "escalation-criteria",
  Setup = "setup",
  Code = "code",
}

interface useDetectorDetailSettingsProps {
  detectorFetchData?: Detector;
  fetchDetectorError?: Error;
  updateDetector: (arg: any) => Promise<Detector>;
  getDetector: (route?: string | undefined) => Promise<Detector>;
  hasImageQueries: boolean
}

export const useDetectorDetailSettings = (props: useDetectorDetailSettingsProps) => {
  const { detectorFetchData, fetchDetectorError, updateDetector, getDetector, hasImageQueries } =
    props;

  const [value, setValue] = useState(hasImageQueries ? DetectorTabs.Escalation : DetectorTabs.Code);
  const [committedConfidenceThreshold, setCommittedConfidenceThreshold] = useState(DEFAULT_CONFIDENCE_THRESHOLD);
  const [editableDetectorFields, setEditableDetectorFields] = useState<EditableDetectorFields>({
    confidence_threshold: DEFAULT_CONFIDENCE_THRESHOLD,
    set: { id: "", name: "" },
  });

  useEffect(() => {
    if (detectorFetchData && !fetchDetectorError) {
      if (detectorFetchData.confidence_threshold !== committedConfidenceThreshold) {
        setEditableDetectorFields({
          confidence_threshold: detectorFetchData.confidence_threshold,
          set: detectorFetchData.set,
        });
        setCommittedConfidenceThreshold(detectorFetchData.confidence_threshold);
      }
    }
  }, [committedConfidenceThreshold, detectorFetchData, fetchDetectorError]);

  const handleTabsChange = (_: React.SyntheticEvent, newValue: DetectorTabs) => {
    setValue(newValue);
  };

  const onConfidenceThresholdCommitted = async (value: number) => {
    setEditableDetectorFields({ ...editableDetectorFields, confidence_threshold: value });
    try {
      await updateDetector({
        confidence_threshold: value,
      });
      await getDetector();
      setCommittedConfidenceThreshold(value);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    value,
    handleTabsChange,
    onConfidenceThresholdCommitted,
    editableDetectorFields,
    setEditableDetectorFields,
  };
};
